import React from "react";
import { CompanyCompensationContainer } from "../../containers";

const CompanyCompensation = (props) => {
  return <CompanyCompensationContainer {...props} />;
};

export default CompanyCompensation;
